module.exports = {
    controller: ecicsListController,
    templateUrl: 'ecics/components/ecics-list.html'
};

ecicsListController.$inject = ['ecicsDataService'];

function ecicsListController(ecicsDataService) {
    var vm = {
        service: ecicsDataService,
        changeActiveItem: ecicsDataService.changeActiveItem,
        isLoading: false,
        loadMore: loadMore
    };
    return vm;

    function loadMore() {
        vm.isLoading = true;
        ecicsDataService.loadMoreItems().then(function () {
            vm.isLoading = false;
        });
    }
}